import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import { ReactComponent as Chevron } from '../../../assets/images/arrow-cheveron-down.svg';
import styles from './CollapseButton.module.css';
import classNames from 'classnames';

const CollapseButton = ({
    closeText = 'View Less',
    openText = 'View More',
    customClass = '',
    collapseContent, //Content can be single string or array of strings
    collapseContentClass = '',
    title = '' //Title text will lead collapse button
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const collapseDisplay = (content) => {
        if (typeof content === 'string') {
            return <p className={classNames(collapseContentClass)}>{content}</p>;
        } else {
            return content.map((data) => <p className={classNames(collapseContentClass)}>{data}</p>);
        }
    };

    return (
        <div>
            <div className={styles.buttonLinkContainer}>
                {title.length !== 0 && title}
                <a
                    onClick={() => setIsOpen(!isOpen)}
                    className={classNames(`${customClass}`, styles.linkText)}
                >
                    {isOpen ? closeText : openText}
                    <Chevron className={classNames(styles.arrow, isOpen ? styles.active : styles.closed)} />
                </a>
            </div>
            <Collapse isOpen={isOpen}>
                <div>{collapseDisplay(collapseContent)}</div>
            </Collapse>
        </div>
    );
};

export default CollapseButton;
